import React, { useState, useEffect } from 'react';

const ServerStatus = () => {
  const [servers, setServers] = useState([]);
  const [error, setError] = useState(null);

  const fetchServerStatus = () => {
    fetch('/server_status', {
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Fetched server data:', data);
        if (data && data.status === 'success' && data.data && data.data.servers) {
          setServers(data.data.servers);
        } else {
          throw new Error('Invalid server data format');
        }
      })
      .catch(error => {
        console.error('Error fetching server data:', error);
        setError('Failed to load server data');
      });
  };

  useEffect(() => {
    // Initial fetch
    fetchServerStatus();

    // Set interval to fetch server status every 10 seconds
    const intervalId = setInterval(fetchServerStatus, 10000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const handleStartServer = (serverName) => {
    fetch('/start_server', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ name: serverName }),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to start server');
        }
        return response.json();
      })
      .then(() => {
        // Refresh server status after starting
        fetchServerStatus();
      })
      .catch(error => {
        console.error('Error starting server:', error);
        setError('Failed to start server');
      });
  };

  const handleTerminateServer = (serverName) => {
    fetch('/terminate_server', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ name: serverName }),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to terminate server');
        }
        return response.json();
      })
      .then(() => {
        // Refresh server status after terminating
        fetchServerStatus();
      })
      .catch(error => {
        console.error('Error terminating server:', error);
        setError('Failed to terminate server');
      });
  };

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!servers.length) {
    return <div>Loading...</div>;
  }

  return (
    <div className="server-status">
      <h2>Server Status</h2>
      <div className="servers-grid">
        {servers.map(server => (
          <div key={server.name} className="server-card">
            <h3>{server.name}</h3>
            <p>IP: {server.ip}</p>
            <p>Status: {server.status}</p>
            <p>Zone: {server.zone}</p>
            {server.status === 'TERMINATED' && (
              <button onClick={() => handleStartServer(server.name)}>Start</button>
            )}
            {server.status === 'RUNNING' && (
              <button onClick={() => handleTerminateServer(server.name)}>Terminate</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServerStatus; 